import './App.css';
import Calc from './Calc';

function App() {
  return (
    <div className="App">
      <Calc/>
    </div>
  );
}

export default App;
